import type { SxProps, Theme } from '@glplus/glpweb-dsl';

/**
 * The DSL Button paints `variant="outlined"` with a SOLID brand-color
 * background AND brand-color text (Button.tsx) — i.e. green-on-green, so the
 * label is invisible. Until that's fixed in the DSL, secondary/neutral and
 * destructive buttons pass these sx overrides to force a readable outlined look
 * (white fill, dark/red text, light border).
 */
export const NEUTRAL_BTN: SxProps<Theme> = {
  backgroundColor: '#ffffff',
  color: '#343F5B',
  borderColor: '#cfd9d3',
  '&:hover': { backgroundColor: '#f3f5f4', borderColor: '#b9c4bd' },
};

export const DANGER_BTN: SxProps<Theme> = {
  backgroundColor: '#ffffff',
  color: '#C0392B',
  borderColor: '#e6b0aa',
  '&:hover': { backgroundColor: '#fdf2f1', borderColor: '#d98880' },
};
